import React, { Component } from "react";
import "../../css/salesstats.css";
import { Button, Table} from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
// import ReactChartkick, { ColumnChart } from 'react-chartkick';
// import Chart from 'chart.js';
import { ReportService } from "../../Services/ReportService";
import { Constants } from "../../Constants";
import { formatNumber, format_date_only_new } from "../../Utils";
import EnhancedTableToolbar from "../../components/EnhancedTableToolbar";
import XLSX from 'xlsx';
import { Paper } from "@material-ui/core";

// ReactChartkick.addAdapter(Chart)

export default class StoresB2W extends Component {

    constructor(props) {
      super(props);
      this.state = {
        data: [],
        rows: [],
        startDate: moment().subtract(7, "days"),
        endDate: moment(),
        message : "",
        exportLoading: false
      }
      this.handleChangeStart = this.handleChangeStart.bind(this);
      this.handleChangeEnd = this.handleChangeEnd.bind(this);
    }
    
 
    componentDidMount(){
        this.props.setTitle('Stores Best to Worst');
        this.fetchData();
    }

    fetchData(){
        let rows = [];
        this.props.isLoading(true);
        ReportService.getReportStoresB2W(Constants.STORE, this.state.startDate, this.state.endDate)
        .then((data) => {
            console.log(data);
            let dataIn = [];
            data.report.forEach(element => {
                    dataIn.push([element.store_name, element.total_amount])
                    rows.push(<ReportDetails key={element.store_name} report={element}/>);
            });
            this.setState({data: dataIn, rows: rows, master_data: data.report})
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    handleChangeStart(date){
        this.setState({
            startDate: date
        });
    }

    handleChangeEnd(date){
        this.setState({
            endDate: date
        });
    }

    exportReport = () => {
        let data = this.state.master_data;
        this.setState({exportLoading: true});
        if(data && data.length > 0){
            let sheetname = 'Store Sales Report';
            let exportData = [];
            exportData = [["Sl No", "Store", "Agent", "Total Sales", "Avg Sales"]];
            data.forEach((row, index) => {
                    exportData.push([index+1, row.store_name, row.agent_name, parseFloat(row.total_amount), parseFloat(row.total_amount) / parseFloat(row.days)]);
            });

            if(exportData){
                const wb = XLSX.utils.book_new();
                const wsAll = XLSX.utils.aoa_to_sheet(exportData);
                XLSX.utils.book_append_sheet(wb, wsAll, sheetname );
                XLSX.writeFile(wb, sheetname + ".xlsx");
            }
            this.setState({exportLoading: false});
        } else {
            this.props.showSnackBar('Nothing to export', 'error');
            this.setState({exportLoading: false});
        }
    }
    
    render() {
        let { message, exportLoading} = this.state;
        return (
            <div className="Home sales-stats" style={{marginTop: 32}}>
                <Paper style={{paddingTop: 16, paddingBottom: 16, padding: 8}}>
                    <div className="rangeContainer">
                    <div className="centerwrapper">
                        <div className = "squareLabel marginRight">From</div>
                        <div className = "square">
                            <DatePicker
                                selected={this.state.startDate}
                                selectsStart
                                dateFormat={format_date_only_new}
                                startDate={this.state.startDate}
                                endDate={this.state.endDate}
                                onChange={this.handleChangeStart} />
                        </div>
                        <div className = "squareLabel">To</div>
                        <div className = "square">
                            <DatePicker
                                selected={this.state.endDate}
                                selectsEnd
                                dateFormat={format_date_only_new}
                                startDate={this.state.startDate}
                                endDate={this.state.endDate}
                                onChange={this.handleChangeEnd}
                            />
                        </div>
                        <div className = "square">
                            <Button onClick={(e) => { this.fetchData(e)}}>REFRESH</Button>
                        </div>
                    </div>
                    </div>
                    {/* { !this.props.loading &&
                        <div className="container">
                            <ColumnChart donut={true} data={this.state.data}/>
                        </div>
                    } */}
                    { !this.props.loading &&
                        <div className="">
                            <EnhancedTableToolbar title="" exportReport={this.exportReport} showProgress loading={exportLoading}/>
                        </div>
                    }
                    { !this.props.loading &&
                        <Table striped condensed hover responsive>
                            <thead>
                                <tr>
                                    <th>Store</th>
                                    <th>Agent</th>
                                    <th style={{textAlign: "right"}}>Total Sales (INR)</th>
                                    <th style={{textAlign: "right"}}>Avg Sales (INR)</th>
                                </tr>
                            </thead>
                            <tbody style={{textAlign: "left"}}>
                                {this.state.rows}
                            </tbody>
                        </Table>
                    }
                    {
                        message && 
                        (
                            <p style={{color:"red", paddingLeft:"20px"}}>{message}</p>
                        )
                    }
                </Paper>
            </div>
        );
    }

}

class ReportDetails extends Component {

    render(){
        const report = this.props.report;
        const avg = parseFloat(report.total_amount) / parseFloat(report.days)
        return (
            <tr>
                <td>{report.store_name}</td>
                <td>{report.agent_name}</td>
                <td style={{textAlign: "right"}}>{formatNumber(report.total_amount)}</td>
                <td style={{textAlign: "right"}}>{formatNumber(avg)}</td>
            </tr>
        );
    }
}